import React, { useEffect, useRef, useState } from "react";
import { Container, Col, Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { getEmployeesBroker } from "../../slices/broker/thunk";
import Loading from "../../Components/Loading";
import EmployeesTable from "../../Components/Tables/EmployeesTable/EmployeesTable";
import EditEmployeeModal from "../../Components/modals/EmployeesModal/EditEmployeeModal";
import NavTabEmployee from "../../Components/Tabs/NavTabEmployee";
import { getStatusEmployees } from "../../utils/utils";
import SearchBar from "../../Components/SearchBar/SearchBar";
import HeadersRole from "../../Components/Headers/HeadersRole";
import employeesIcon from "../../assets/images/iconsRoles/employeesIcon.svg";

const DashboardEmployeesBroker = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("1");

  const [currentPage, setCurrentPage] = useState(0);

  const [isTerminated, setIsTerminated] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const [employeesBroker, setEmployeesBrokerBroker] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [countByStatus, setCountByStatus] = useState({
    active: 0,
    terminated: 0,
    pending: 0,
  });

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };
  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchBrokerEmployees = async () => {
    const statusEmployees = getStatusEmployees(isTerminated, isPending);
    try {
      setLoading(true);
      const response = await dispatch(
        getEmployeesBroker({
          status: statusEmployees,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setCountByStatus({
        active: response.countByStatus?.active,
        terminated: response.countByStatus?.terminated,
        pending: response.countByStatus?.pending,
      });
      setEmployeesBrokerBroker(response.data);
      setTotalEmployees(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchBrokerEmployees();
  }, [isTerminated, isPending, currentPage, debouncedSearchTerm, dispatch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const filteredEmployeesBroker =
    employeesBroker &&
    employeesBroker.filter((employee) => {
      const employeeCodeStr = employee.employeeCode
        ? employee.employeeCode.toString().toLowerCase()
        : "";

      return (
        employee.firstName.toLowerCase().includes(searchTerm) ||
        employee.lastName.toLowerCase().includes(searchTerm) ||
        employee.email.toLowerCase().includes(searchTerm) ||
        employeeCodeStr.includes(searchTerm)
      );
    });

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});

  const hanldeRefreshTable = () => {
    fetchBrokerEmployees();
  };

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Employees"}
            icon={employeesIcon}
            svg={true}
            text=""
          />
          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex justify-content-between align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />
                </div>
              </div>

              <Col xl={12}>
                <NavTabEmployee
                  loading={loading}
                  toggleTab={toggleTab}
                  activeTab={activeTab}
                  countByStatus={countByStatus}
                />
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployeesTable
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        shouldShowImportMessage={false}
                        activeTab={activeTab}
                        data={employeesBroker}
                        onRefreshTable={hanldeRefreshTable}
                        onEditClick={handleEditClick}
                        paginationProps={{
                          itemsCount: employeesBroker.length,
                          totalPages: totalPages,
                          totalItems: totalEmployees,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                        isTerminated={isTerminated}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardEmployeesBroker;
